module.exports = __webpack_public_path__ + "img/校徽.5be86b5e.png";